/**
 * @note
 * for hook alternative of route element composition:
 * - https://reactrouter.com/docs/en/v6/upgrading/v5#use-useroutes-instead-of-react-router-config
 * - https://reactrouter.com/docs/en/v6/examples/route-objects
 *
 * might need to take notes on:
 * - https://reactrouter.com/docs/en/v6/upgrading/v5#note-on-link-to-values
 */

import { Suspense } from "react";

import { Route, Routes } from "react-router-dom";

import Layout from "../layout/Layout";
import SignInPage from "../pages/SignInPage";
import SignUpPage from "../pages/SignUpPage";
import { privateRoutes, routes } from "./routes";

import RequireAuth from "~/components/auth/RequireAuth";
import Page404 from "~/pages/404/404Page";
import { withRenderTally } from "~/utils/withRenderTally";

// Wrap auth pages with render tallying
const SignInPageWithTally = withRenderTally(SignInPage, "SignInPage");
const SignUpPageWithTally = withRenderTally(SignUpPage, "SignUpPage");
const Page404WithTally = withRenderTally(Page404, "404Page");

const Routings = () => {
  return (
    <Suspense>
      <Routes>
        <Route path="/signin" element={<SignInPageWithTally />} key={"/signin"} />
        <Route path="/signup" element={<SignUpPageWithTally />} key={"/signup"} />

        {routes.map((routeProps) => (
          <Route
            path={routeProps.path}
            element={<Layout>{routeProps.element}</Layout>}
            key={routeProps.path as string}
          />
        ))}
        {privateRoutes.map(({ element, bodyPadding, bgColor, ...privateRouteProps }) => (
          <Route
            element={
              <RequireAuth redirectTo={`/signin?redirectTo=${privateRouteProps.path}`}>
                {
                  <Layout bodyPadding={bodyPadding} bgColor={bgColor}>
                    {element}
                  </Layout>
                }
              </RequireAuth>
            }
            {...privateRouteProps}
            key={`privateRoute-${privateRouteProps.path}`}
          />
        ))}
        <Route path="*" element={<Page404WithTally />} />
      </Routes>
    </Suspense>
  );
};

export default Routings;
